module.exports = __webpack_public_path__ + "static/media/background-victual.24dd5785.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/background-victual.jpg
// module id = 102
// module chunks = 0